<div class="page-content" *ngIf="!timerService.isForwarding">

      <div><button class="btn-back" title="{{Button.Back_alt | translate}}" (click)="onPreviousClick()" translate>{{Button.Previous}}</button></div>
 
      <h1 [hidden]="parentCount>=2" class="page-title" translate="aboutParent.page_title"></h1>
      <h1 [hidden]="parentCount<=1" class="page-title" translate="aboutParent.page_titles"></h1>
 
      <div class="bottom-1"> {{'aboutParent.section_intro1'|translate:childNameParam}} </div>
      <div class="bottom-1"> {{'aboutParent.section_intro2'|translate:childNameParam}} </div>
 
      <accordion label="aboutParent.accord_whoCanListed.header" input-class="">
                 <div translate="aboutParent.accord_whoCanListed.text1"></div>
                 <ul>
                       <li translate="aboutParent.accord_whoCanListed.list1"></li>
                       <li translate="aboutParent.accord_whoCanListed.list2"></li>
                       <li translate="aboutParent.accord_whoCanListed.list3"></li>
                       <li translate="aboutParent.accord_whoCanListed.list4"></li>
                       <li translate="aboutParent.accord_whoCanListed.list5"></li>
                 </ul>
                 <div translate="aboutParent.accord_whoCanListed.text2"></div>
      </accordion>
 
      <form>

         <div id="name_{{i}}" *ngFor="let parent of parents; let i = index"  style="margin-top:0.8em; margin-bottom:1.2em">
             <h2 [hidden]="i>=1" translate="aboutParent.parentName"></h2>
             <h2 [hidden]="i==0" translate="aboutParent.nextParentName"></h2>
 
             <ng-input    [(ng-model)]="parent.name.first"   size="50" id="firstName{{i}}"
                          [(ng-error)]="errors[i].firstName" option="8"
                          [ng-disable]="parent.name.chk_singleName=='Y'"
                                 label="aboutParent.firstName.label"
                                  [if]="i==0"
                              alt-text="aboutParent.firstName.alt$">
                              <span [hidden]="!isCustodyOtherThanParent||parent.isGiveBirth=='Y'" translate>{{'-text.optional'}}</span>
             </ng-input>
 
             <ng-input    [(ng-model)]="parent.name.middle"    size="50" margin="/0.5" id="middleName{{i}}"
                          [(ng-error)]="errors[i].middleName"  option="8"
                          [ng-disable]="parent.name.chk_singleName=='Y' || parent.name.chk_middleNA"
                                 label="aboutParent.middleName.label"
                                  [if]="i==0"
                              alt-text="aboutParent.middleName.alt$">
                              <span [hidden]="!isCustodyOtherThanParent||parent.isGiveBirth=='Y'" translate>{{'-text.optional'}}</span>
             </ng-input>
 
             <ng-checkbox [(ng-model)]="parent.name.chk_middleNA" 
                          [(ng-clear)]="errors[i].middleName"  (change)="parent.name.middle=''"
                          [ng-disable]="parent.name.chk_singleName=='Y'" margin="0.5/">
                                       {{'aboutParent.middleName.NA'}}
             </ng-checkbox>
 
             <ng-input    [(ng-model)]="parent.name.last"   size="50" margin="/0.5" id="lastName{{i}}"
                          [(ng-error)]="errors[i].lastName" option="8"
                          [ng-disable]="parent.name.chk_singleName=='Y' || parent.isLastNameLocked"
                                 label="aboutParent.lastName.label"
                                  [if]="i==0"
                              alt-text="aboutParent.lastName.alt$">
             </ng-input>
             <!--  ***** Single Name Start ****  -->
             <ng-checkbox  id="single_{{i}}"
                           [(ng-model)]="parent.name.chk_singleName" outer-class="top-2" 
                           (change)="onSingleNameChange(i)" margin="0.5/">
                            {{'aboutParent.singleName.chk_label'}}
             </ng-checkbox>            
 
             <accordion label="aboutParent.singleName.accordHead" 
                        margin="1.85|0" [(open)]="parent.isASNOpen">
                                     {{'aboutParent.singleName.accordText'}}
             </accordion>
 
             <div [hidden]="parent.name.chk_singleName!='Y'">
 
                  <ng-input    [(ng-model)]="parent.name.single"    size="50" id="singleName{{i}}" 
                               [(ng-error)]="errors[i].singleName"  option="8"
                               [ng-disable]="parent.isLastNameLocked"
                                      label="aboutParent.singleName.label"
                                       [if]="i==0"
                                   alt-text="aboutParent.singleName.alt$">
                  </ng-input>
             </div>
             <!--  ***** Single Name End ****  -->
 
             <div id="giveBirthDiv{{i}}">
             <ng-radio id="giveBirth_{{i}}" 
                       [hidden]="isSurrogate || parentCount==1 || i>=1 && parents[i-1].isGiveBirth != 'N'"
                       [(ng-model)]="parent.isGiveBirth" 
                       [ng-disable]="data.isNextChild"
                       [(ng-error)]="errors[i].giveBirth" 
                       [item-list]="items.yesNoList"    margin="1/"
                       [label-param]="childNameParam" 
                        (change)="onGiveBirthChange(i)">
                          <h3 translate="aboutParent.giveBirth.didThisParent"
                              [translateParams]="childNameParam"></h3>
             </ng-radio>
            </div>
         </div>  <!-- end of parent loop -->
         <div aria-live='assertive'>
         <notice-box [hidden]="!isNoGiveBirth">
                     <div style="padding-bottom: 1em;" translate="aboutParent.giveBirth.alert_text1" [translateParams]="parentCntParam"></div>
                     <div style="padding-bottom: 1em;" translate="aboutParent.giveBirth.alert_text2"></div>
                     <div innerHTML="{{'aboutParent.giveBirth.alert_text3'|translate}}"></div>
         </notice-box>
         </div>    
      </form>
 
      
      <div style="margin-top:2.4em">
              <div translate="aboutParent.parent_on_BR"></div>
              <div class="light-grey" style="padding:0.1em 0.2em">
                  <div *ngFor="let parent of parents" 
                       [hidden]="!parent.name.completed()"
                        style="margin:0.4em 0 0.2em 0.4em">
                        
                        <strong> {{parent.name.getFullName()}} </strong>
                        <span [hidden]="parent.isGiveBirth!='Y'" style="margin-left:2.2em">
                                    ({{'aboutParent.gaveBirth'|translate}})
                        </span>
                        
                  </div>
              </div>
      </div>
 
      <div id="unableToCertify" [hidden]="!isUnableToCertify">
 
            <div [hidden]="certyfyingCount!=1" style="margin-top:2em" >

                  <div style="margin-bottom:0.5em" translate="aboutParent.certify.whichParent"></div>

                  <div *ngFor="let parent of parents; let i=index" [hidden]="!parent.name.completed()" name="parentCertify">
                        <ng-radio1 [(ng-model)]="selectedParent" [value]="i"  
                                    [(ng-clear)]="error_parent2"  [id]="'certify_'+i"
                                    
                                    (change)="onCertifyingParent2Change()" width="2.2em"></ng-radio1>
                        <label [for]="'radio_certify_'+i" 
                                    style="display:inline-block; vertical-align:middle" >
                                    {{parent.name.getFullName()}}
                        </label>
                  </div>

                  <errors [hidden]="!error_parent2"  [error]="error_parent2"></errors>
            </div>

            <div [hidden]="certyfyingCount==1">
                  <div style="margin:2em 0 0.8em" translate="aboutParent.certify.whichParents"></div>
                  <div style="margin-left:0.2em">
                        <div *ngFor="let parent of parents; let i=index" [hidden]="!parent.name.completed()">
                        <ng-checkbox [(ng-model)]="parent.isCertifyingParent"  id="cert_{{i}}"
                                     [ng-disable]="isCertifiedDisable"
                                     [(ng-clear)]="error_parent3" width="1.8em">
                        </ng-checkbox>
                        <label [class.disable-label]="isCertifiedDisable" style="display:inline-block" for="chkbox_cert_{{i}}">{{parent.name.getFullName()}}</label>
                        </div>

                        <errors [hidden]="!error_parent3" [error]="error_parent3"></errors>
                  </div>
            </div>

      </div>
                 
 
      <div class="btn-div" style="margin-top:1.5em">
           <div><button class="btn-next"  [alt-text]="Button.Next_alt" 
                       (click)="onNextClick()" translate>{{Button.Next}}</button></div>
      </div>
 
 </div>
 